import { Container } from 'react-bootstrap';
import { FC, useState } from 'react';
import { RadioSelector } from 'src/components/_commons';
import { UsersNewUserCreate } from './UsersNewUserCreate';
import { UsersNewUserInvite } from './UsersNewUserInvite';

type propsType = {
    closeShowNewUser: () => void;
};

export const UsersNewUser: FC<propsType> = ({ closeShowNewUser }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [radioValue, setRadioValue] = useState('1');

    return (
        <Container className={'maxw-400 mt-4'}>
            <RadioSelector
                options={[
                    { label: radioValue === '' ? 'Viendo Invitar' : 'Ver Invitar', type: '1' },
                    { label: radioValue === '' ? 'Viendo Crear' : 'Ver Crear', type: '2' }
                ]}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue === '1' ?
                <UsersNewUserInvite
                    closeShowNewUser={closeShowNewUser}
                    email={email}
                    setEmail={setEmail}
                />
                :
                <UsersNewUserCreate
                    closeShowNewUser={closeShowNewUser}
                    email={email}
                    password={password}
                    setEmail={setEmail}
                    setPassword={setPassword}
                />
            }

        </Container>
    );
}
